export default {"src":"/_next/static/media/bids.cf28ee57.svg","height":71,"width":72,"blurWidth":0,"blurHeight":0};